import axios from '@/libs/api.request'
// 导师端预约接口
const appointmentService = {
  // 预约待确认列表
  appointUncomfirmList (data) {
    return axios.request({
      url: '/ugd/appointment/unconfirm/list',
      data,
      method: 'POST'
    })
  },
  // 预约未开始列表
  appointUnfinishedList (data) {
    return axios.request({
      url: '/ugd/appointment/notStarted/list',
      data,
      method: 'POST'
    })
  },
  // 预约待反馈列表
  appointTofeedbackList (data) {
    return axios.request({
      url: '/ugd/appointment/tofeedback/list',
      data,
      method: 'POST'
    })
  },
  // 预约已完成列表
  appointFinishedList (data) {
    return axios.request({
      url: '/ugd/appointment/finish/list',
      data,
      method: 'POST'
    })
  },
  // 预约详情
  appointDetail (data) {
    return axios.request({
      url: '/ugd/appointment/detail',
      data,
      method: 'POST'
    })
  },
  // 预约待确认-确认操作
  appointUncomfirmSub (data) {
    return axios.request({
      url: '/ugd/appointment/confirm',
      data,
      method: 'POST'
    })
  },
  // 预约待反馈-确认操作
  appointFeedbackSub (data) {
    return axios.request({
      url: '/ugd/feedback/save',
      data,
      method: 'POST'
    })
  },
  timeTransition: data => {
    return axios.request({
      url: '/ugd/appointment/timetransition',
      data,
      method: 'post'
    })
  }
}

export default appointmentService
